// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** upload Signature Start ************************/
export const signatureUpload = (verifyData: any) => {
	const data = {
		UploadSignatureToken: verifyData,
	};
	const url = `${API_URL}memberSignatureUpload`;
	return makeApiCall(url, data);
};
/** ***************** upload Signature End ************************/
